// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"10f45e14","223":"df7550cb"}[chunkId] + ".chunk.js";
};